import { useBlocksConfig, useSyncer } from "@pathwright/blocks-engine"
import { AudioPlayer, MediaManager } from "@pathwright/legacy-media-manager"
import { getAudioType } from "@pathwright/media-utils"
import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import AllowDownload from "../../utils/AllowDownload"
import { AudioEditWrapper, Row } from "./ui"
import { mediaToAudioBlock } from "./utils"

const AudioEdit = (props) => {
  const { onChange, data, blockStyles } = props
  const { contextKey, userID, accountID, isSuperuser } = useBlocksConfig()
  const { blocksContext } = useSyncer()
  const mediaStoragePath = blocksContext?.mediaStoragePath

  const handleChangeAudio = (mediaItem) => {
    const audio = mediaToAudioBlock(mediaItem)

    onChange({ ...audio })
  }

  const handleToggleDownloadable = () => {
    const allowDownload = !data.allowDownload

    onChange({ allowDownload })
  }

  return (
    <AudioEditWrapper>
      <MediaManager
        contextKey={contextKey}
        mediaStoragePath={mediaStoragePath}
        mediaType="audio"
        onChooseMedia={handleChangeAudio}
        userID={userID}
        accountID={accountID}
        renderButton={({ onClick }) => (
          <Button
            styleType="primary"
            size="medium"
            onClick={onClick}
            className="EditButton"
            style={{ marginTop: "20px", color: "#fff" }}
          >
            <Pathicon icon="shuffle" style={{ marginRight: "0.5rem" }} />
            Replace Audio
          </Button>
        )}
        isSuperuser={isSuperuser}
        className="mm--replace-audio"
        downloadURL={data.downloadURL}
      />
      <AudioPlayer
        src={data.downloadURL}
        trackTitle={data.name}
        allowDownload={true}
        customStyles={blockStyles}
        type={getAudioType(data.type)}
      />
      <Row>
        <AllowDownload
          allowDownload={data.allowDownload}
          onChange={handleToggleDownloadable}
          textColor={blockStyles ? blockStyles.styleAttributes.color : ""}
        />
      </Row>
    </AudioEditWrapper>
  )
}

export default AudioEdit
